var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-city-code container"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('b-table',{attrs:{"striped":true,"bordered":true,"fixed":true,"fields":_vm.tableData.fields,"items":_vm.citys}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center mt-3"},[_c('div',{staticClass:"city-title"},[_vm._v("家庭住宅短效代理城市列表")])])
}]

export { render, staticRenderFns }